<svg
  class="block"
  [attr.width]="width"
  [attr.height]="height"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 17 17"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.75 12.4939V14.25C6.75 15.0784 7.42157 15.75 8.25 15.75C9.07843 15.75 9.75 15.0784 9.75 14.25V12.4939M8.25 0.75V1.5M1.5 8.25H0.75M3.375 3.375L2.92493 2.92493M13.125 3.375L13.5752 2.92493M15.75 8.25H15M12.75 8.25C12.75 10.7353 10.7353 12.75 8.25 12.75C5.76472 12.75 3.75 10.7353 3.75 8.25C3.75 5.76472 5.76472 3.75 8.25 3.75C10.7353 3.75 12.75 5.76472 12.75 8.25Z"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
